module.exports = __webpack_public_path__ + "static/img/B1.849e73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/B1.png
// module id = olcX
// module chunks = 0